/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto } from '../models/Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsOutputDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsOutputDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_HoldingSummaryOutputDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_HoldingSummaryOutputDto';
import type { Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto } from '../models/Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto';
import type { Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto } from '../models/Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DashboardAppSharedService {

    /**
     * @returns Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantDashboard(): CancelablePromise<Wealthlane_AwardService_Dtos_Dashboard_ParticipantDashboardResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-dashboard',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantHoldingDetails(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_HoldingDetailsOutputDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-holding-details',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_HoldingSummaryOutputDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardParticipantHoldingSummary(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_HoldingSummaryOutputDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard/participant-holding-summary',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardAppSharedParticipantHoldingDetailsV1(): CancelablePromise<Wealthlane_AwardService_Dtos_ParticipantTask_PortfolioSummaryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard-app-shared/participant-holding-details-v1',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppDashboardAppSharedParticipantTradePreClearance(): CancelablePromise<Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/dashboard-app-shared/participant-trade-pre-clearance',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
